import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },
  methods: {
    openRefundsDetail() {
      this.params.context.componentParent.$refs.vendorDetailModal.openRefundsDetail(
        this.params.data.id
      );
    }
  },
  template: `
        <span class="no-underline hover:underline cursor-pointer" v-on:click="openRefundsDetail">
            {{this.params.value}}
        </span>
    `
});
